export const SET_TEMPLATE = "SET_TEMPLATE";
export const GET_TEMPLATE = "GET_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";